enum ArmorialType {
    armoiries = 'armes',
    iconographie = 'iconographie',
    administration = 'administration'
}

export default ArmorialType;